import { Component } from '@angular/core';
import { Istage } from 'src/framework/Istage';
import { DecoderLayoutComponent } from '../core/decoder.layout.component';

@Component({
    selector: 'app-decoderlayoutmobile',
    templateUrl: './decoder.layout.mobile.component.html',
    styleUrls: ['../css/decoder.layout.mobile.component.scss'],
    standalone: false
})
export class DecoderLayoutMobileComponent extends DecoderLayoutComponent {
  layoutdataMobile: Istage = {
    stageWidth: 720,
    stageHeight: 1280,
    stageLeft: 0,
    stageTop: 0,
    stageZ: 999,
    position: 'absolute',
    overflow: 'hidden',
    name: 'updatescale',
  };

  constructor() {
    super();
  }
  ngOnDestroy() {
    delete this.layoutdataMobile;
  }
}
